const RegionBlock = ({ name, sub, tel, website, imgSrc, altText, dataVal }) => {
  return (
    <div className="section-block">
      <div className="section-title flexbox flex-flow-row-no-wrap flex-align-items-center flex-justify-space-between">
        <div className="section-title-name flexbox">
          <div>{name}</div>
          {sub && <div className="section-title-sub">{sub}</div>}
        </div>
        <div className="section-title-links flexbox flex-flow-column-no-wrap">
          <div className="section-title-links-ctn flexbox flex-align-items-center flex-justify-end">
            {tel && (
              <div>
                <a href={`tel:${tel}`} className="link-telephone">Téléphone</a>
              </div>
            )}
            <div>
              <a
                href={website}
                className="link-web js-region-update"
                data-val={dataVal}
                target="_blank"
                rel="noopener noreferrer"
              >
                Site Internet
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="section-img" data-val={dataVal}>
        <a
          className="js-region-update"
          data-val={dataVal}
          href={website}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={imgSrc} alt={altText} />
        </a>
      </div>
    </div>
  );
};

export default RegionBlock;
